import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import type { AuthCredentials } from '@/utils/auth'

type ImpersonateUserRequest = {
  email: string
}

// Same `{ token, role }` shape as POST /session.
const impersonateUser = async (data: ImpersonateUserRequest) => {
  const response = await authAPI.post<AuthCredentials>('/impersonate', data)
  return response.data
}

export const useImpersonateUser = () => {
  return useMutation({
    mutationFn: impersonateUser,
  })
}
